import createIcon from '../../createIcon';

/**
 * @component @name SportsMma
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyMEM3IDIwLjU1IDcuNDUgMjEgOCAyMUgxNkMxNi41NSAyMSAxNyAyMC41NSAxNyAyMFYxN0g3VjIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDdDMTcuNDUgNyAxNyA3LjQ1IDE3IDhWNUMxNyAzLjkgMTYuMSAzIDE1IDNIN0M1LjkgMyA1IDMuOSA1IDVWMTAuOEM1IDEwLjkzIDUuMDEgMTEuMDYgNS4wNCAxMS4xOUw1Ljg0IDE1LjE5QzUuOTMgMTUuNjYgNi4zNCAxNS45OSA2LjgyIDE1Ljk5SDE3QzE3LjU1IDE1Ljk5IDE4LjA5IDE1LjU1IDE4LjIgMTUuMDFMMTguOTcgMTEuMThDMTguOTkgMTEuMDYgMTkgMTAuOTMgMTkgMTAuOFY4QzE5IDcuNDUgMTguNTUgNyAxOCA3Wk0xNyAxMC42QzE3IDEwLjczIDE2LjM2IDE0IDE2LjM2IDE0SDcuNjRDNy42NCAxNCA3IDEwLjc0IDcgMTAuNlY1SDE1VjEwSDE3VjEwLjZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQgN0g4VjEwSDE0VjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsMma = createIcon('SportsMma', [
  ['path', { d: 'M7 20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V17H7V20Z', key: '127suw' }],
  [
    'path',
    {
      d: 'M18 7C17.45 7 17 7.45 17 8V5C17 3.9 16.1 3 15 3H7C5.9 3 5 3.9 5 5V10.8C5 10.93 5.01 11.06 5.04 11.19L5.84 15.19C5.93 15.66 6.34 15.99 6.82 15.99H17C17.55 15.99 18.09 15.55 18.2 15.01L18.97 11.18C18.99 11.06 19 10.93 19 10.8V8C19 7.45 18.55 7 18 7ZM17 10.6C17 10.73 16.36 14 16.36 14H7.64C7.64 14 7 10.74 7 10.6V5H15V10H17V10.6Z',
      key: '1qmmxy',
    },
  ],
  ['path', { d: 'M14 7H8V10H14V7Z', key: '12zazf' }],
]);

export default SportsMma;
